import { render, staticRenderFns } from "./Megadrive.vue?vue&type=template&id=dd14ef50&"
import script from "./Megadrive.vue?vue&type=script&lang=js&"
export * from "./Megadrive.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("F:\\Node\\megadrive\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('dd14ef50')) {
      api.createRecord('dd14ef50', component.options)
    } else {
      api.reload('dd14ef50', component.options)
    }
    module.hot.accept("./Megadrive.vue?vue&type=template&id=dd14ef50&", function () {
      api.rerender('dd14ef50', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Megadrive.vue"
export default component.exports